const theme_desktop = {
  mode: "main",
  palette: {
    primary: {
      main: "#0560fb",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "linear-gradient(to left,#1e358c,#4866d9)",
      contrastText: "#ffffff",
    },
    error: {
      main: "#d32f2f",
      contrastText: "#ffffff",
    },
    success: {
      main: "green",
      contrastText: "#ffffff",
    },
    warning: {
      main: "orange",
      contrastText: "#ffffff",
    },
    info: {
      main: "blue",
      contrastText: "#ffffff",
    },
  },
  shape: {
    borderRadius: "5px",
  },
  typography: {
    fontFamily: "Open Sans",
    lineHeight: "normal",
    letterSpacing: "0.35px",
    title: {
      fontSize: "20px",
      fontWeight: "600",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "800",
    },
    text: {
      fontSize: "14px",
      fontWeight: "400",
    },
  },
};

module.exports = theme_desktop